import { Component, ElementRef, OnInit, ViewChild } from '@angular/core';
import { ApiService } from "../../../services/http/api.service";
import { ApiConfiguration } from "../../../services/http/api-configuration";
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { FormGroup, FormBuilder, FormControl, Validators } from '@angular/forms';
import { ToastClientService } from "../../../services/toast/toast-client.service";
import { RegionProvider } from '../../shared/providers/region.provider';
import { RegionModel } from '../../shared/models/region';
import { XlsxService } from 'src/app/services/xlsx/xlsx.service';
import { XlsxViewComponent } from 'src/app/shared/xlsx-view/xlsx-view.component';
import { ExportExcelService } from 'src/app/shared/xlsx-view/export-excel.service';
import { brandExcelHeaders } from '../../shared/models/mock-data';
import { HttpEventType, HttpResponse } from '@angular/common/http';
import { FileService } from 'src/app/services/file/file.service';
import { UploadZipService } from 'src/app/services/upload-zip/upload-zip.service';

@Component({
  selector: 'app-brands',
  templateUrl: './brands.component.html',
  styleUrls: ['./brands.component.scss']
})

export class BrandsComponent implements OnInit {

  addOrEditBrand: string;
  brands = [];
  formGroup;
  deletePopupUiData;
  isEnabledCheck: Boolean;
  tempOptionModel;
  brandsListHeaders:any;
  progress:number = 0;
  getAllCategoryAndSubCategory:any = {category:[],subCategory:[]};
  excelFileName:string = null;
  states: RegionModel[];
  filteredDetails: any = {
    search_string:'',
    category: [],
    sku: '',
  };
  filteredDetailsForApi:any = {
    search_string:'',
    category: '',
    sku: '',
  };
  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private fb: FormBuilder,
    private modalService: NgbModal,
    public toast: ToastClientService,
    public regionProvider: RegionProvider,
    private xlsx: XlsxService,
    public exportExcelService: ExportExcelService,
    public fileService:FileService,
    private uploadFile:UploadZipService,
  ) {}

  regions: RegionModel[];

  ngOnInit() {
    this.getAllBrands(this.filteredDetailsForApi);
    // this.getAllCategory();
    // this.getAllSubCategory();
    this.getExcelBrandsFields();

  }

  toggleCheck(){
    this.isEnabledCheck = !this.isEnabledCheck;
  }


  getExcelBrandsFields() {
    this.apiService.get(this.apiConfig.productUploadExcelFields)
      .subscribe((res: any) => {
        if(res.data){
          let headers = Object.keys(res.data.product_fields);
          this.brandsListHeaders = headers;
        }

      }, err => {
        console.log(err);
      })
  }

  // ngDoCheck() {
  //   this.regions = this.regionProvider.regions;
  //   this.states = this.regionProvider.states;
  // }

  addBrand(targetModal) {
    this.addOrEditBrand = 'add'

    this.formGroup = this.fb.group({
      brand_name: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$')]),
      brand_desc: new FormControl('', [Validators.required, Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$')]),
      program_id: 1
    });

    this.showBrandModal(targetModal);
  }

  get f() {
    return this.formGroup.controls;
  }

  editBrand(targetModal, brandInfo){
    this.addOrEditBrand = 'edit'
    if(brandInfo.is_loyalty == 1){
      this.isEnabledCheck = true
    }else{
      this.isEnabledCheck = false
    }
    this.formGroup = this.fb.group({
      brand_id: brandInfo.id,
      brand_name: new FormControl(brandInfo.brand_name, [Validators.required, Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$')]),
      brand_desc: new FormControl(brandInfo.brand_desc, [Validators.required, Validators.pattern('^[A-Za-z0-9 _]*[A-Za-z0-9][A-Za-z0-9 _]*$')]),
      program_id: 1
    });

    this.showBrandModal(targetModal);
  }

  deleteBrand(targetModal, brandInfo){
    this.addOrEditBrand = 'delete'
    this.deletePopupUiData = brandInfo.brand_name;

    this.formGroup = this.fb.group({
      brand_id: brandInfo.id,
      program_id: 1
    });

    this.showBrandModal(targetModal);
  }

  showBrandModal(targetModal){
    this.modalService.open(targetModal, {
      centered: true,
      backdrop: 'static'
    });
  }

  submitted = false;

  onSubmitBrand(formData) {

    this.submitted = true;

    if(this.formGroup.invalid){
      return
    }

    let apiUrl;
    if(this.addOrEditBrand == 'add'){
      formData.par_brand_id = formData.brand_name;
      apiUrl = this.apiConfig.configAddBrand

    } else if(this.addOrEditBrand == 'edit'){
      formData.par_brand_id = formData.brand_name;
      //Is enabled check for edit.
      if(this.isEnabledCheck == true){
        formData.is_loyalty = 1
      }else{
        formData.is_loyalty = 0
      }
      apiUrl = this.apiConfig.configEditBrand

    } else if(this.addOrEditBrand == 'delete'){
      apiUrl = this.apiConfig.configDeleteBrand
    }

      this.apiService.post(apiUrl, formData)
      .subscribe((res:any)=>{
        this.toast.Success("successfully updated");
        this.brandActionSuccess(formData);
      },err=>{
        console.log('err', err);
      })

  }

  brandActionSuccess(data){
    this.modalService.dismissAll();
    this.getAllBrands(this.filteredDetailsForApi);
  }

  /**
   * @auth kailash_dev
   */
  /** Add new brands section */
  getAllCategory() {
    this.apiService.get(this.apiConfig.getAllCategiry)
      .subscribe((res: any) => {
        if(res.data){
          this.getAllCategoryAndSubCategory.category = res.data.ecommerce_categories;
          console.log(res.data);
        }

      }, err => {
        console.log(err);
      })
  }
  getAllSubCategory() {
    this.apiService.get(this.apiConfig.getEcommerceSubCategories)
      .subscribe((res: any) => {
        if(res.data){
          this.getAllCategoryAndSubCategory.subCategory = res.data.ecommerce_sub_categories;
        }

      }, err => {
        console.log(err);
      })
  }
  showuploadTemplateModal(targetModal){
    this.tempOptionModel = this.modalService.open(targetModal, {
      centered: true,
      // backdrop: 'static'
    });
  }
  closeoptionModel(){
    this.tempOptionModel.close();
  }
  downloadFile() {
    let excelHeader
    if(this.brandsListHeaders){
      excelHeader = this.brandsListHeaders;
    }else{
      excelHeader = brandExcelHeaders;
    }
    this.exportExcelService.exportBrandExcel(excelHeader,'Add_brands_',this.getAllCategoryAndSubCategory);
  }
  uploadXlsx(eve){
    if(eve.target.files){
      this.excelFileName = eve.target.files[0].name;
    }
    this.xlsx.uploadXlsx(eve).then(res => {
      this.xlsxView(res);
    });
  }
  xlsxView(data){
    // data.apiHeaders = this.brandsListHeaders;
    this.closeoptionModel();
    let modalRef =this.modalService.open(XlsxViewComponent, {
      centered: true,
      backdrop: 'static',
      size: 'xl',
      scrollable: true,
      windowClass : "ExcelTemplateViewModal"
    });
    modalRef.componentInstance.xlsxDatas = data;
    modalRef.result.then((result) => {
      if(result){
        this.uploadMultiData(result);
      }
    }, (reason) => {
    });
  }

  uploadMultiData(data){
    this.enableUploadDiv(data);
    // this.apiService.post(this.apiConfig.uploadMultiProducts, data)
    //   .subscribe((res:any)=>{
    //     this.toast.Success('Brands added successfully!');
    //     this.getAllBrands();
    //   },err=>{
    //     console.log('err', err);
    //   })
  }
  enableUploadDiv(data){
    this.uploadFile.changeMessage({status:'upload',data:data,url:this.apiConfig.uploadMultiProducts,module:'Brands',excelname:this.excelFileName});
  }
   /* Fillter section start */
   async selectedItem(data, serviceId) {
    switch (serviceId) {
      case 1: // State
        this.filteredDetails.category = await this.formateFillters( data,"category");
      default:
        break;
    }
  }
  formateFillters(data, name) {
    if (data.status == "singleSelect") {
      this.filteredDetails[name].push(data.data.id);
      return this.filteredDetails[name];
    } else if (data.status == "singleDeselect") {
      this.filteredDetails[name].forEach((element, i) => {
        if (element == data.data.id) {
          this.filteredDetails[name].splice(i, 1);
        }
      });
      return this.filteredDetails[name];
    } else if (data.status == "SelectAll") {
      this.filteredDetails[name] = [];
      if (data.data) {
        data.data.forEach((element) => {
          this.filteredDetails[name].push(element.id);
        });
      }
      return this.filteredDetails[name];
    } else if (data.status == "unSelectAll") {
      this.filteredDetails[name] = [];
      return this.filteredDetails[name];
    }
  }
  filterListOfRecords(){
    try {
      this.filteredDetailsForApi.search_string = this.filteredDetails.search_string;
      this.filteredDetailsForApi.sku = this.filteredDetails.sku;
      this.filteredDetailsForApi.category = [...this.filteredDetails.category].toString();
    } catch (error) {    }
    console.log(this.filteredDetailsForApi);
    this.getAllBrands(this.filteredDetailsForApi);
  }
  getAllBrands(data) {
    this.apiService.getHeaders(this.apiConfig.configGetBrands+'?brand_category_id='+data.category+'&brand_name='+data.search_string+'&sku='+data.sku)
      .subscribe((res: any) => {
        if(res.body.data){
          this.brands = res.body.data;
        }
      }, err => {
        console.log(err);
      })
  }
}
